import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, Tooltip } from 'reactstrap';
import del from '../Res/Icon/delete.png';
import remove from '../Res/Icon/remove.png';
import resend from '../Res/Icon/resend.png';
import recover from '../Res/Icon/recover.png';
import delivered from '../Res/Tags/Delivered.png';
import cancelled from '../Res/Tags/Cancelled.png';
import failed from '../Res/Tags/Failed.png';
import sending from '../Res/Tags/Sending.png';
import download from '../Res/Icon/download.png';

import './Fax.css';
import utils from '../lib/utils';

const Fax = ({
  fax,
  onDelete,
  onCancel,
  onResend,
  onDownload,
  user: userApp,
  onSelectNumber,
  deleteMode,
  onRecover,
}) => {
  const {
    _id: id,
    status,
    reason,
    updatedOn,
    user,
    company,
    relayNumber,
    destinationNumber,
    totalPages,
  } = fax;
  const [tipDelete, setTipDelete] = useState(false);
  const [tipResend, setTipResend] = useState(false);
  const [tipCancel, setTipCancel] = useState(false);
  const [tipDownload, setTipDownload] = useState(false);

  const toggle = e => {
    if (e === 'delete') {
      setTipDelete(true);
      setTipResend(false);
      setTipCancel(false);
      setTipDownload(false);
    } else if (e === 'resend') {
      setTipDelete(false);
      setTipResend(true);
      setTipCancel(false);
      setTipDownload(false);
    } else if (e === 'cancel') {
      setTipDelete(false);
      setTipResend(false);
      setTipCancel(true);
      setTipDownload(false);
    } else if (e === 'download') {
      setTipDelete(false);
      setTipResend(false);
      setTipCancel(false);
      setTipDownload(true);
    }

    setTimeout(() => {
      setTipDelete(false);
      setTipResend(false);
      setTipCancel(false);
      setTipDownload(false);
    }, 1500);
  };
  return (
    <tr>
      {/* {userApp.role === 'superAdmin' || (userApp.role === 'companyGroupAdmin' && <td>{id}</td>)} */}
      <td>{company.name}</td>
      <td>{reason}</td>
      <td>{user.email}</td>
      <td>{totalPages}</td>
      <td>{utils.getDateTimeFormat(updatedOn, 'regular')}</td>
      <td className="number-table-box" onClick={() => onSelectNumber(relayNumber, 'src')}>
        {relayNumber}
      </td>
      <td className="number-table-box" onClick={() => onSelectNumber(destinationNumber, 'dest')}>
        {destinationNumber}
      </td>
      <td>
        {status === 'Delivered' ? (
          <img className="actions-tags" src={delivered} alt="delivered" />
        ) : status === 'Sending' ? (
          <img className="actions-tags" src={sending} alt="sending" />
        ) : status === 'Failed' || status === 'failed' ? (
          <img className="actions-tags" src={failed} alt="failed" />
        ) : (
          <img className="actions-tags" src={cancelled} alt="cancelled" />
        )}
      </td>
      {!deleteMode ? (
        <td>
          <div style={{ display: 'flex' }}>
            {((userApp?.role === 'admin' || userApp?.role === 'enterpriseAdmin') &&
              userApp?.company?.permissions?.showFaxDownload) ||
              (user._id === userApp?._id && userApp?.company?.permissions?.showFaxDownload) ? (
              <>
                <Tooltip
                  placement={'bottom'}
                  isOpen={tipDownload}
                  target={'download' + id}
                  toggle={() => toggle('download')}
                >
                  Download
                </Tooltip>
                <img
                  id={'download' + id}
                  onClick={() => {
                    onDownload(id);
                  }}
                  className="actions-icon"
                  src={download}
                  alt="..."
                />
              </>
            ) : null}
            <Tooltip
              placement={'bottom'}
              isOpen={tipDelete}
              target={'delete' + id}
              toggle={() => toggle('delete')}
            >
              Delete
            </Tooltip>
            <img
              onClick={() => {
                onDelete(id);
              }}
              id={'delete' + id}
              className="actions-icon"
              src={del}
              alt="delete"
            />
            {status === 'Sending' ? (
              <>
                <Tooltip
                  placement={'bottom'}
                  isOpen={tipCancel}
                  target={'cancel-' + id}
                  toggle={() => toggle('cancel')}
                >
                  Cancel
                </Tooltip>
                <img
                  onClick={() => {
                    onCancel(id);
                  }}
                  id={'cancel-' + id}
                  className="actions-icon"
                  src={remove}
                  alt="remove"
                />
              </>
            ) : status === 'Failed' || status === 'failed' || status === 'Cancelled' ? (
              <>
                <Tooltip
                  placement={'bottom'}
                  isOpen={tipResend}
                  target={'resend' + id}
                  toggle={() => toggle('resend')}
                >
                  Resend
                </Tooltip>
                <img
                  onClick={() => {
                    onResend(id);
                  }}
                  id={'resend' + id}
                  className="actions-icon"
                  src={resend}
                  alt="resend"
                />
              </>
            ) : null}
          </div>
        </td>
      ) : (
        <td>
          <div style={{ display: 'flex' }}>
            <img
              onClick={() => {
                onDelete(id);
              }}
              className="actions-icon"
              src={del}
              alt="delete"
            />
            <img
              onClick={() => onRecover(id)}
              className="actions-icon"
              src={recover}
              alt="recover"
            />
          </div>
        </td>
      )}

      {/* <FaxStatus status={status} retryCount={retryCount} /> */}
    </tr>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
});

export default connect(mapStateToProps)(Fax);
